<div class="quick-phrase-form-container p-fluid p-formgrid p-grid" [formGroup]="form">
  <div class="p-field p-col-12 p-md-11">
    <input type="text" pInputText placeholder="Quick Phrase" formControlName="phrase" />
  </div>
  <div class="p-field p-col-12 p-md-1">
    <p-button icon="pi pi-times" styleClass="p-button-danger p-button-text" (click)="remove.emit()"></p-button>
  </div>

  <div class="p-field p-col-12 p-md-6" formGroupName="translation">
    <input type="text" pInputText placeholder="Spanish Translation" formControlName="es" />
  </div>
  <div class="p-field p-col-12 p-md-6" formGroupName="translation">
    <input type="text" pInputText placeholder="English Translation" formControlName="en" />
  </div>

  <div class="p-field p-col-12 p-md-6">
    <input type="text" pInputText placeholder="URL (Optional)" formControlName="url" />
  </div>
  <div class="p-field p-col-12 p-md-6">
    <input type="text" pInputText placeholder="Transcription (Optional)" formControlName="transcription" />
  </div>
</div>
<p-divider></p-divider>
